$(document).ready(function(){

    (function ($) {

        // quick search regex
        var qsRegex; // text search
        var buttonFilter; // category search
        var currentCount; // the number of results 

        // init Isotope. All 3rd party code
        var $grid = $('.grid').imagesLoaded( function()
        {
            $grid.isotope({
                itemSelector: '.element-item',
                layoutMode: 'fitRows',
                filter: function()
                {
                    var $this = $(this);
                    var searchResult = qsRegex ? $this.text().match( qsRegex ) : true;
                    var buttonResult = buttonFilter ? $this.is( buttonFilter ) : true;
                    return searchResult && buttonResult;
                }
            });
        });

        // use value of search field to filter
        var $quicksearch = $('#quicksearch').keyup( debounce( function() 
        {
            qsRegex = new RegExp( $quicksearch.val(), 'gi' );
            $grid.isotope();
            currentCount = $grid.data('isotope').filteredItems.length;
            updateCounter();
            updateOtherGroups();

        }) );

        // use the value of a select box to do a filter
        $('#category_filter').on( 'change', function() 
        {
            buttonFilter = $(this).val();
            $grid.isotope(); // build the grid (isosope grid)
            currentCount = $grid.data('isotope').filteredItems.length;
            updateCounter();
            updateOtherGroups();
        });

        // debounce so filtering doesn't happen every millisecond
        function debounce( fn, threshold ) {
            var timeout;
            threshold = threshold || 100;
            return function debounced() {
                clearTimeout( timeout );
                var args = arguments;
                var _this = this;
                function delayed() {
                    fn.apply( _this, args );
                }
                timeout = setTimeout( delayed, threshold );
            };
        }


        // this is the most complex/custom function
        // uses data-slug (post slug) to rebuild lists
        // uses data-mapswitch along with marker id to rebuild map markers
        // Google maps is awkward
        function updateOtherGroups()
        {

            var $current_items = $grid.data('isotope').filteredItems; // isotope goes first
            var slugs = [];
            var markersOn = [];

            // loop through isotope results and fill the above two arrays
            // basically is isotope has it on, then add it to array
            for (i = 0; i < $current_items.length; i++) 
            {
                var slug = $current_items[i]['element']['dataset']['slug'];
                var markerslug = $current_items[i]['element']['dataset']['mapswitch'];
                if (slug && slug !== undefined)
                {
                    slugs.push(slug);
                    if (markerslug && markerslug !== undefined)
                    {
                        markersOn.push(markerslug);
                    }
                }
            } 

            // list mode could use jQuery slideup and slidedown if we wanted, but it could get messy
            // this one simply hides if we don't want it, or removes hide if we do
            $('.list-listing .list-container').each(function () {
                var slug_now = $(this).data('slug');
                if (slugs.indexOf(slug_now) > -1)
                {
                    $(this).removeClass("hide");
                }
                else
                {
                    $(this).addClass("hide");
                }
            });
        }

        // update the user showing counter
        function updateCounter()
        {
            var updatedCount = currentCount + " Item" + (currentCount == 1 ? "" : "s");
            $('#page-counter-results').html(updatedCount);
        }

        
        $(document).ready(function () 
        {

            // if you re-order filters when not in the grid tab, it all goes mad.
            // this re-orders
            $("#grid-engage").click(function ()
            {
                //alert("hi7");
                //$grid('reloadItems').isotope();

                setTimeout( function() 
                {
                    $grid.isotope();
                }, 300);

            });
        });


    })(jQuery);

});